// extracted by mini-css-extract-plugin
export var background = "_6r-0";
export var container = "_6r-1";
export var contentItem = "_6r-7";
export var extendedWarranty = "_6r-5";
export var link = "_6r-d";
export var modal = "_6r-b";
export var modalCloseButton = "_6r-9";
export var modalContent = "_6r-3";
export var modalContentMain = "_6r-6";
export var modalImageLogo = "_6r-8";
export var modalLogo = "_6r-a";
export var modalSideImage = "_6r-4";
export var preview = "_6r-c";
export var redoModal = "_6r-2";